/* BCB PDP Deferred Scripts v2 (8 Tem 2026)
 * Combines non-critical inline scripts into a single cacheable, deferred file.
 * Loaded with defer - runs after DOM parse, before DOMContentLoaded.
 * v2: Koala kaldirildi, wholesale CTA Fly Bundles (gfb*) widget'ina tasindi.
 */

(function() {
  'use strict';

  /* --- 1. FBT Gift Wrapping auto-uncheck (TODO-199) --- */
  function uncheckGiftWrap() {
    document.querySelectorAll('.cbb-frequently-bought-selector-input').forEach(function(cb) {
      if (cb.getAttribute('aria-label') && cb.getAttribute('aria-label').toLowerCase().indexOf('gift wrapping') !== -1 && cb.checked) {
        cb.checked = false;
        cb.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }
  var giftWrapTimer = setInterval(function() {
    if (document.querySelector('.cbb-frequently-bought-selector-input')) {
      clearInterval(giftWrapTimer);
      uncheckGiftWrap();
    }
  }, 300);
  setTimeout(function() { clearInterval(giftWrapTimer); }, 10000);

  /* --- 2. Wholesale CTA under Fly Bundles quantity breaks (28 Sub 2026, 8 Tem 2026: koala -> gfb) --- */
  function initBundleNote() {
    var w = document.querySelector('.gfbVolumeDiscountWidgetWrapper');
    if (!w || document.querySelector('.bcb-wholesale-cta')) return;
    var ws = document.createElement('div');
    ws.className = 'bcb-wholesale-cta';
    var _wh = location.pathname.split('/products/')[1] || '';
    ws.innerHTML = '<span class="bcb-ws-text">Need 10+ units?</span> <a href="/pages/wholesale' + (_wh ? '?product=' + _wh : '') + '" onclick="try{dataLayer.push({event:\'wholesale_cta_click\',event_category:\'engagement\',event_label:location.pathname})}catch(e){}">Buy at wholesale price &rarr;</a>';
    w.appendChild(ws);
  }

  var bundleTimer = setInterval(function() {
    if (document.querySelector('.gfbVolumeDiscountWidgetWrapper')) { clearInterval(bundleTimer); initBundleNote(); }
  }, 300);
  setTimeout(function() { clearInterval(bundleTimer); }, 10000);

  /* --- 3. Wholesale page GA4 tracking (28 Sub 2026) --- */
  if (location.pathname === '/pages/wholesale') {
    try {
      window.dataLayer = window.dataLayer || [];
      dataLayer.push({ event: 'wholesale_page_view', event_category: 'engagement', page_path: '/pages/wholesale' });
    } catch (e) {}
    var form = document.querySelector('#ws-form form');
    if (form) {
      form.addEventListener('submit', function() {
        try {
          var type = document.getElementById('ws-type');
          var vol = document.getElementById('ws-volume');
          dataLayer.push({
            event: 'wholesale_inquiry_submit',
            event_category: 'lead',
            wholesale_business_type: type ? type.value : '',
            wholesale_volume: vol ? vol.value : ''
          });
        } catch (e) {}
      });
    }
  }

  /* --- 4. Shopify Chat (Inbox) delayed activation --- */
  /* Chat widget loads via content_for_header (can't prevent download).
   * This delays the visual appearance until user has been on page 5s or scrolls.
   * Saves ~256KB from blocking initial TTI calculation. */
  var chatRevealed = false;
  function revealChat() {
    if (chatRevealed) return;
    chatRevealed = true;
    var style = document.getElementById('bcb-chat-delay');
    if (style) style.remove();
  }
  // Reveal after 5 seconds or on first scroll/click
  setTimeout(revealChat, 5000);
  var revealEvents = ['scroll', 'click', 'touchstart'];
  revealEvents.forEach(function(evt) {
    window.addEventListener(evt, revealChat, { once: true, passive: true });
  });
})();
